import { Component, OnInit, ViewChild } from '@angular/core';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { LanguageService } from '../../services/language.service';
import { User } from '../../models/user.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

  images = [
    'assets/images/home-image-1.png',
    'assets/images/home-image-2.png',
    'assets/images/home-image-3.jpg'
  ];

  public config: SwiperConfigInterface = {
    direction: 'horizontal',
    autoplay: {
      delay: 8000
    },
    init: true,
    slidesPerView: 1,
    effect: 'fade',
  };

  @ViewChild(SwiperComponent, { static: true }) componentRef: SwiperComponent;
  @ViewChild(SwiperDirective, { static: false }) directiveRef: SwiperDirective;

  public user = {login: '', password: ''};
  public lastLoginFailed = false;

  constructor(private router: Router,
              private authService: AuthService,
              private languageService: LanguageService) {
  }

  ngOnInit() {
    this.authService.currentUser.subscribe(currentUser => {
      if (currentUser) {
        if (this.authService.isAdmin) {
          this.router.navigateByUrl('/dealer-management').then();
        } else {
          this.router.navigateByUrl('/overview').then();
        }
      }
    });
  }

  login() {
    this.lastLoginFailed = false;
    this.authService.login(this.user.login, this.user.password).then((user: User) => {
      if (user && user.language) {
        this.languageService.changeLanguage(user.language);
      }
    }, error => this.loginError(error));
  }

  loginError(error) {
    this.lastLoginFailed = true;
    this.user.login = '';
    this.user.password = '';
  }

  removeLoginError() {
    this.lastLoginFailed = false;
  }

  forgotPassword() {
    this.router.navigate(['forgot-password']).then();
  }

}
